/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'camera': {
    width: 16,
    height: 16,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M28 28H4c-1.7 0-3-1.3-3-3V10c0-1.7 1.3-3 3-3h4.5l1.1-1.7c.5-.8 1.5-1.3 2.5-1.3H20c1 0 1.9.5 2.5 1.3l1 1.7H28c1.7 0 3 1.3 3 3v15c0 1.7-1.3 3-3 3zM4 9c-.6 0-1 .4-1 1v15c0 .6.4 1 1 1h24c.6 0 1-.4 1-1V10c0-.6-.4-1-1-1h-5.5l-1.7-2.6c-.2-.2-.5-.4-.9-.4H12c-.3 0-.6.2-.8.4L9.5 9H4z"/><path pid="1" d="M16 24.1c-3.9 0-7.1-3.2-7.1-7.1s3.2-7.1 7.1-7.1 7.1 3.2 7.1 7.1-3.2 7.1-7.1 7.1zm0-12c-2.7 0-4.9 2.2-4.9 4.9s2.2 4.9 4.9 4.9 4.9-2.2 4.9-4.9-2.2-4.9-4.9-4.9z"/>'
  }
})
